"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _selectFilter = _interopRequireDefault(require("./select-filter.store"));
var _selectFilter2 = require("../../../utils/filters/select-filter.utils");
var _dec, _dec2, _dec3, _dec4, _class;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SingleSelectFilter = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class = function (_SelectFilter) {
  (0, _inherits2.default)(SingleSelectFilter, _SelectFilter);
  function SingleSelectFilter() {
    var _this;
    (0, _classCallCheck2.default)(this, SingleSelectFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SingleSelectFilter, [].concat(args));
    _this.$env = void 0;
    _this.id = 'single-select';
    return _this;
  }
  (0, _createClass2.default)(SingleSelectFilter, [{
    key: "initialize",
    value: function initialize(data, query, withCommit) {
      if (query === void 0) {
        query = '';
      }
      if (withCommit === void 0) {
        withCommit = true;
      }
      this.data = data;
      if (withCommit) {
        this.state = this.uncommittedState;
      }
      if (query) {
        this.update(query, withCommit);
      }
    }
  }, {
    key: "toggle",
    value: function toggle(code) {
      if (this.isSelected(code)) {
        this.reset(true);
      } else {
        this.set(code, true);
      }
    }
  }, {
    key: "set",
    value: function set(code, withCommit) {
      if (withCommit === void 0) {
        withCommit = false;
      }
      this.uncommittedState = (0, _selectFilter2.setSingleSelectState)(this.uncommittedState, code);
      withCommit && this.commit();
    }
  }, {
    key: "update",
    value: function update(query, withCommit) {
      if (withCommit === void 0) {
        withCommit = false;
      }
      if (!query || typeof query !== 'string') {
        this.reset(withCommit);
      } else {
        this.set(query, withCommit);
      }
    }
  }]);
  return SingleSelectFilter;
}(_selectFilter.default), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "initialize", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "toggle", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "set", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "update", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype)), _class));